import httpClient from '@/shared/http-eserv-client';

const appRelativeUrl = '/applicationrequests/MyRequests';
const inProgressFilter = '$filter=isClosed eq false and isSubmitted eq false';
const submittedFilter = '$filter=isSubmitted eq true';
const closedFilter = '$filter=isClosed eq true';

const getApplications = (userId) => httpClient.get(`${appRelativeUrl}?userId=${userId}`);

const getInProgressApplications = (userId, topNumber) => {
  const itemsNumberFilter = topNumber && topNumber > 0 ? `&$top=${topNumber}` : '';
  return httpClient.get(`${appRelativeUrl}?userId=${userId}&${inProgressFilter}&${itemsNumberFilter}`);
};

const getSubmittedApplications = (userId, topNumber) => {
  const itemsNumberFilter = topNumber && topNumber > 0 ? `&$top=${topNumber}` : '';
  return httpClient.get(`${appRelativeUrl}?userId=${userId}&${submittedFilter}&${itemsNumberFilter}`);
};

const getClosedApplications = (userId, topNumber) => {
  const itemsNumberFilter = topNumber && topNumber > 0 ? `&$top=${topNumber}` : '';
  return httpClient.get(`${appRelativeUrl}?userId=${userId}&${closedFilter}&${itemsNumberFilter}`);
};

const deleteApplication = (data) => httpClient.post('/applicationrequests', data);
const getPDF = (userId, accessToken, requestId) => httpClient.get(`/applicationrequests/pdf?userId=${userId}&securitytoken=${accessToken}&requestId=${requestId}`);
const getHistoryPDF = (userId, accessToken, requestId, submitRound) => httpClient.get(`/applicationrequests/pdf?userId=${userId}&securitytoken=${accessToken}&requestId=${requestId}&reviewRound=${submitRound}`);
const getHistoryPDFByDocumentId = (userId, accessToken, documentId) => httpClient.get(`/documents/OpenGenerateFile?userId=${userId}&securitytoken=${accessToken}&documentId=${documentId}`);

export {
  getApplications,
  getInProgressApplications,
  getSubmittedApplications,
  getClosedApplications,
  deleteApplication,
  getPDF,
  getHistoryPDF,
  getHistoryPDFByDocumentId,
};
